import _defineProperty from "/workdir/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js";
import _asyncToGenerator from "/workdir/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/asyncToGenerator.js";
import _regeneratorRuntime from "/workdir/node_modules/next/dist/compiled/@babel/runtime/regenerator/index.js";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

import { createAction } from "@reduxjs/toolkit";
import { emitSearch } from "@catchoftheday/analytics";
import { parseQueryString, retry } from "@catchoftheday/utilities";
import { searchProducts } from "@search-app/api";
import { allAppliedFacets } from "@search-app/utilities/facets/applied";
import { createAsyncThunk, formatSearchResults } from "../../utils"; // Toggle the facet filters modal on mobile

export var searchFacetsVisiblity = createAction("search/facets/VISIBILITY");
/**
 * Fetch new Search Results
 */

export var searchFetch = createAsyncThunk("search/fetch", /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
  var query, _parseQueryString, searchTerm, _yield$retry, contexts, payload, config, seo, facets, metadata, results, searchResults, appliedFacets, result;

  return _regeneratorRuntime.wrap(function _callee$(_context) {
    while (1) {
      switch (_context.prev = _context.next) {
        case 0:
          query = globalThis.location.search;
          _parseQueryString = parseQueryString(query), searchTerm = _parseQueryString.query;
          _context.next = 4;
          return retry(searchProducts)({
            query: query
          });

        case 4:
          _yield$retry = _context.sent;
          contexts = _yield$retry.contexts;
          payload = _yield$retry.payload;
          config = _yield$retry.config;
          seo = _yield$retry.seo;
          facets = payload.facets, metadata = payload.metadata, results = payload.results;
          emitSearch({
            snowplowContexts: contexts
          });
          searchResults = formatSearchResults(metadata, results);
          appliedFacets = allAppliedFacets(facets);
          result = {
            facets: facets,
            metadata: _objectSpread(_objectSpread({}, metadata), {}, {
              query: metadata.query || searchTerm
            }),
            results: searchResults,
            searchConfig: config,
            seo: seo,
            contexts: contexts,
            appliedFacets: appliedFacets
          };
          return _context.abrupt("return", result);

        case 15:
        case "end":
          return _context.stop();
      }
    }
  }, _callee);
})));